/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in 
 *                 part without express written permission of Honeywell Inc. 
 *                 is prohibited.
 *
 * Name          :  noticeRequestSuccessful.tsx
 * 
 * Project Title :  Checkout
 *  
 * Description	:  H224423
 * 
 * 
 * Company       : Honeywell Technology Solutions , Hyderabad
 * 
 * @Author       : 
 * 
 * @Date			: Dec 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Dec 30, 2019
 * Description   : Added Modification history and UT test cases.
 *
*******************************************************************************/

import * as React from 'react';
import { Modal, Button, Icon } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './noticeRequestSuccessful.css';

interface InoticeRequestSuccessfulState {
    open: any,
    hasClickOut: any
}

interface InoticeRequestSuccessfulProps {
    stateOptions?: any;
    content?: any;
}

class NoticeRequestSuccessful extends React.Component<InoticeRequestSuccessfulProps, InoticeRequestSuccessfulState> {

    constructor(props: InoticeRequestSuccessfulProps) {
        super(props);
        this.state = {
            open: true,
            hasClickOut: true,
        };
    }

    render() {
        return (
            <React.Fragment>

                {this.renderModal()}

            </React.Fragment>
        );
    }

    renderModal() {
        return (
            <Modal closeIcon={true} onClose={() => this.setState({ open: false })} size="large" open={this.state.open}
                closeOnDimmerClick={this.state.hasClickOut} closeOnDocumentClick={this.state.hasClickOut} className="selectAccountModal">
                <Modal.Header>
                    Notice
                </Modal.Header>

                <Modal.Content>
                    <Icon name="check" size="medium" color="#7EB338" /><b>Request Successful.</b>
                    <br /><br />
                    Thank you for providing the details. An Account Management Representative will contact you within the next 24-48 hours regarding your request.
                </Modal.Content>

                <Modal.Footer>
                    <div>
                        <Button type="primary" size="medium" content="OK" onClick={() => this.setState({ open: false })} />
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default NoticeRequestSuccessful;